import Vue from 'vue'
import ALloading from "./ALloading";

const LoadingConstructor = Vue.extend(ALloading)

var instance = null
const loading = {
  show() { // 显示方法
    if (!instance){
      instance = new LoadingConstructor({el: document.createElement('div')})
    }
    instance.show = true
    document.body.appendChild(instance.$el)
  },
  hide() { // 隐藏方法
    if (instance){
      instance.show = false
    }
  }
}

export default {
  install() {
    if (!Vue.$loading) {
      Vue.$loading = loading
    }
    Vue.mixin({
      created() {
        this.$loading = Vue.$loading
      }
    })
  }
}




//////////////////
// WEBPACK FOOTER
// ./app/components/loading/loading.js
// module id = null
// module chunks = 